import React, { useState, useEffect } from 'react';

import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';

export const FingotiDelete = ({ remove, onClick, tooltipText, className, disabled }) => {

    const [confirmDelete, setConfirmDelete] = useState(false);
    let timeout;

    useEffect(() => {
        return () => {
            clearTimeout(timeout);
        }
    }, [])

    const handleConfirm = () => {
        setConfirmDelete(true);
        timeout = setTimeout(() => setConfirmDelete(false), 3000)
    }

    return (
        <Tooltip title={confirmDelete ? "click again to confirm" : tooltipText}>
            {
                remove ?
                    <IconButton disabled={disabled} className={className} onClick={confirmDelete ? onClick : handleConfirm}>
                        {
                            confirmDelete ?
                                <ErrorOutlineOutlinedIcon style={{ fill: '#ff9800' }} />
                                :
                                <HighlightOffIcon />
                        }
                    </IconButton>
                    :
                    <IconButton disabled={disabled} className={className} onClick={confirmDelete ? onClick : handleConfirm}>
                        {
                            confirmDelete ?
                                <ErrorOutlineOutlinedIcon style={{ fill: '#ff9800' }} />
                                :
                                <DeleteOutlineOutlinedIcon />
                        }
                    </IconButton>
            }
        </Tooltip>
    )

}

FingotiDelete.defaultProps = {
    remove: false,
    disabled: false
}